import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }


export default /*#__PURE__*/_defineComponent({
  __name: 'UserVerify',
  props: {
  id: { type: Number, required: true },
  partyId: { type: Number, required: true },
  createdOn: { type: String, required: true },
  updatedOn: { type: String, required: true },
  note: { type: String, required: true },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, _toDisplayString(props.id) + "}", 1),
    _createElementVNode("div", null, _toDisplayString(props.partyId) + "}", 1),
    _createElementVNode("div", null, _toDisplayString(props.createdOn) + "}", 1),
    _createElementVNode("div", null, _toDisplayString(props.updatedOn) + "}", 1),
    _createElementVNode("div", null, _toDisplayString(props.note) + "}", 1)
  ]))
}
}

})